import { Select } from "@/components/ui/select"

// 階数の選択肢（1階〜50階）
const floorOptions = Array.from({ length: 50 }, (_, i) => ({
  value: (i + 1).toString(),
  label: `${i + 1}階`,
}))

interface PropertyFloorSelectorProps {
  value: number | undefined
  onChange: (value: number) => void
  error?: string
  placeholder?: string
  disabled?: boolean
  className?: string
}

export function PropertyFloorSelector({
  value,
  onChange,
  error,
  placeholder = "選択してください",
  disabled = false,
  className,
}: PropertyFloorSelectorProps) {
  return (
    <div className={className}>
      <Select
        value={value?.toString() || ""}
        onChange={(val: string) => onChange(Number(val))}
        options={floorOptions}
        placeholder={placeholder}
        disabled={disabled}
        className="w-full"
      />
      {error && <p className="text-xs text-red-500 mt-1">{error}</p>}
    </div>
  )
}
